$ = require 'jquery'
CardCopyView = require 'app/scripts/views/card/card-copy-view'
CardLabelSelectView = require 'app/scripts/views/label/card-label-select-view'
CardMemberSelectView = require 'app/scripts/views/card/card-member-select-view'
CardMoveView = require 'app/scripts/views/card/card-move-view'
CardViewHelpers = require './card-view-helpers'
CardViewMixins = require './card-view-mixins'
DatePickerView = require 'app/scripts/views/card/date-picker-view'
{ getKey, Key, registerShortcutHandler, Scope, unregisterShortcutHandler, } = require '@trello/keybindings'
{ defaultRouter } = require 'app/common/router'
PopOver = require 'app/scripts/views/lib/pop-over'
StickerEditView = require 'app/scripts/views/stickers/sticker-edit-view'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ trackSeparator } = require 'app/scripts/views/card/SeparatorCard/SeparatorCard'

module.exports = mixin CardViewHelpers, class QuickCardEditorView extends View
  _.extend(@prototype, CardViewMixins)

  className: 'quick-card-editor'
  isMouseDownOnOverlay: false

  @open: (cardView) ->
    @close()

    $el = cardView.$el
    offset = $el.offset()

    opts =
      width: $el.width()
      left: offset.left
      top: offset.top

    @current = new QuickCardEditorView
      model: cardView.model
      modelCache: cardView.modelCache
    .render(opts)

  @close: ->
    @current?.closeEditor()
    @current = null

  initialize: ->
    registerShortcutHandler(@onShortcut, { scope: Scope.Overlay })

    @makeDebouncedMethods 'render', 'renderStickers', 'renderLabels', 'renderCover', 'renderBadges'

    # We need to subscribe this onRouteChanged function to the router
    # so we would know when a user is navigating away from the page
    # where this was initialized. Otherwise the quick editor would
    # still be open regardless of the page the user navigates to.
    #
    # Specifically if they come to the board from the board list.
    # Without this subscription, after they hit the back button
    # the quick editor would sit on top of the board list page.
    @unsubscribeFromRouter = defaultRouter.subscribe(@onRouteChanged.bind(this))
    @routeWhenOpened = defaultRouter.getRoute().routePath

    @listenTo @model,
      'change:labels': @renderLabelsDebounced
      'change:idLabels': @renderLabelsDebounced
      'change:idAttachmentCover': @renderCoverDebounced
      'change:cover': @renderCoverDebounced
      'change:badges change:due change:subscribed change:isTemplate': @renderBadgesDebounced

    @listenTo @model.labelList, 'add remove reset change', =>
      @renderLabelsDebounced()

    @listenTo @model.memberList, 'add remove reset',
      @frameDebounce @renderMembers

    @listenTo @model.stickerList, 'add remove reset change sort', ->
      @renderStickersDebounced()

    @colorCoversFlagEnabled =
      featureFlagClient.get('remarkable.color-covers', false)

    @shouldRenderFullCover = false

  onRouteChanged: (routeContext) ->
    # Backbone will fire this function once when the editor is opened
    # this conditional is here just to prevent the editor from instantly closing.
    if routeContext.routePath != @routeWhenOpened
      @closeEditor()

  remove: ->
    @unsubscribeFromRouter()
    unregisterShortcutHandler(@onShortcut)
    super

  events:
    'keydown .js-edit-card-title': 'quickCardEditKeydown'
    'click .js-save-edits': 'saveEdits'

    'click .js-stop': 'stopCard'

    'click .js-edit-labels': 'editLabels'
    'click .js-edit-members': 'editMembers'
    'click .js-move-card': 'moveCard'
    'click .js-copy-card': 'copyCard'
    'click .js-edit-due-date': 'editDueDate'
    'click .js-archive': 'archive'
    'click .js-due-date-badge': 'toggleDueDateComplete'

    'click': 'checkCloseEditor'
    'click .js-close-editor': 'closeEditor'

    'mousedown': 'mousedownOnOverlay'

  showCover: ->
    @model.getBoard().getPref('cardCovers') && @model.hasCover()

  showStickers: -> true

  onShortcut: (event) =>
    switch getKey(event)
      when Key.Escape
        @closeEditor()
        track 'Keyboard Shortcuts', 'Esc - Close Quick Card Editor', 'Quick Card Editor'
        event.preventDefault()

      when Key.Enter
        @saveEdits()
        track 'Keyboard Shortcuts', 'Enter - Save Quick Card Edits', 'Quick Card Editor'
        event.preventDefault()

  render: (opts) ->
    data = @model.toJSON()
    data.labels = @model.getLabels()
    data.showCover = @showCover()
    data.hasStickers = @model.hasStickers()
    data.quickEdit = true
    data.members = []
    data.isTemplate = @model.isOnBoardTemplate()
    data.isCardTemplate = !!@model.get('isTemplate')

    # gotta position this thing
    data.left = @cLeft = opts.left
    data.top = @cTop = opts.top
    data.width = @cWidth = opts.width
    # 160 is the width of the controls, which are absolutely positioned
    cRight = @cWidth + @cLeft + 160
    wHeight = $(window).height()
    wWidth = $(window).width()

    if cRight > wWidth
      data.leftButtons = true
      @_usingLeftButtons = true

    @$el.html(
      templates.fill(
        'quick_card_editor',
        data
        {}
      )
    )

    @renderStickers()
    .renderCover()
    .renderLabels()
    .renderBadges()
    .renderMembers()
    .checkShowCover()

    # view.remove() removes the editor from# the DOM, which happens every time
    # we close the editor, so this is okay.
    $('#chrome-container').append @$el

    @calcHeight()

    @focusInput()

    @defer =>
      @$('.quick-card-editor-buttons').addClass('fade-in')

    @$('.js-edit-card-title').autosize()

    @

  calcHeight: ->
    wHeight = $(window).height()
    wWidth = $(window).width()

    # Might overflow the window height so lets make sure that doesn't happen.
    # This needs to happen here because it's in the DOM now and the
    # calculations will be right.
    cHeight = @$('.quick-card-editor-card').outerHeight()
    if @cTop + cHeight > wHeight
      top = wHeight - cHeight - 8
      @$('.quick-card-editor-card').css top: top

    $buttons = @$('.quick-card-editor-buttons')
    bHeight = $buttons.outerHeight()
    bOffset = $buttons.offset()

    if bHeight + bOffset.top > wHeight
      $buttons.css top: cHeight - bHeight

    return

  renderStickers: ->
    # Don't re-render the stickers if we contain something that's in
    # the middle of an edit
    if @$('.sticker.moving, .sticker.rotating').length > 0
      return @

    $stickers = @$('.js-card-stickers').empty()
    subviews = (@subview(StickerEditView, sticker) for sticker in @model.stickerList.models)
    @appendSubviews(subviews, $stickers)

    @$('.list-card').toggleClass('is-stickered', @model.hasStickers())

    @

  checkShowCover: ->

    @$('.list-card')
    .toggleClass('is-covered', @showCover())
    .toggleClass('is-stickered', @model.hasStickers())

    @

  focusInput: ->
    @$('.js-edit-card-title').focus().select()

  showPopOver: (e, viewClass, trackStr, opts = {}) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new viewClass _.extend({ @model, @modelCache }, opts)
      alignRight: @_usingLeftButtons

    track("Quick Card Editor", trackStr, undefined, @model.trackProperty())
    return

  editLabels: (e) ->
    @showPopOver(e, CardLabelSelectView, "Open Label Edit")

  editMembers: (e) ->
    @showPopOver(e, CardMemberSelectView, "Open Member Edit")

  copyCard: (e) ->
    @showPopOver e, CardCopyView, "Open Copy Card",
      onCopy: @closeEditor.bind(@)

  editDueDate: (e) ->
    @showPopOver(e, DatePickerView, "Open Due Date Edit", { trackingCategory: 'quick card editor' })

  moveCard: (e) ->
    onCommit = @closeEditor.bind(@)
    @showPopOver e, CardMoveView, "Open Move Card", { onCommit }

  archive: (e) ->
    Util.stop(e)

    @model.close()
    @closeEditor()

    track("Quick Card Editor", "Archive", undefined, @model.trackProperty())
    return

  quickCardEditKeydown: (e) ->
    if getKey(e) == Key.Enter
      @saveEdits(e)

  saveEdits: (e) ->
    Util.stop(e)

    val = @$('.js-edit-card-title').val().trim()

    if val == @model.get('name')
      @closeEditor()
    else if val != ""
      @model.update({ name: val })
      @closeEditor()
      track("Quick Card Editor", "Save Name", undefined, @model.trackProperty())
      trackSeparator(val, {
        category: 'quick card editor',
        method: 'by editing name'
      })
    else
      @$('.js-edit-card-title').focus().select()

    return

  mousedownOnOverlay: (e) ->
    @isMouseDownOnOverlay = e.target == this.$el[0]

    return

  checkCloseEditor: (e) ->
    if @isMouseDownOnOverlay
      @isMouseDownOnOverlay = false

      if PopOver.isVisible
        PopOver.hide()
      else if @$('.sticker.editing').length > 0
        @stopEditingStickers()
      else
        @closeEditor(e)

    return

  closeEditor: (e) ->
    @remove()
    PopOver.hide()
    track("Quick Card Editor", "Close", undefined, @model.trackProperty())
    return

  stopEditingStickers: ->
    for sticker in _.clone(@model.stickerList.models)
      sticker.trigger('stopEditing')
    return

  stopCard: (e) ->
    Util.stopPropagation(e)
    PopOver.hide()
    return
